
import { Player } from '@/types/player';
import { Video } from '@/types/video';

const transformVideoUrls = (videoData: unknown): Video[] => {
  if (!Array.isArray(videoData)) return [];
  
  return videoData.map((item, index) => {
    // Handle new object format
    if (typeof item === 'object' && item !== null && item.url) {
      return {
        id: item.id || `video-${index}`,
        url: item.url,
        source: item.source || 'Other',
        title: item.title || '',
        description: item.description || '',
        created_at: item.created_at || new Date().toISOString(),
      };
    }
    
    // Handle legacy string format (fallback)
    if (typeof item === 'string') {
      const source = item.includes('youtube.com') || item.includes('youtu.be') ? 'YouTube' :
                    item.includes('hudl.com') ? 'Hudl' :
                    item.includes('ballertv.com') ? 'BallerTV' : 'Other';
      
      return {
        id: `video-${index}`,
        url: item,
        source,
        title: '',
        description: '',
        created_at: new Date().toISOString(),
      };
    }
    
    return {
      id: `video-${index}`,
      url: '',
      source: 'Other',
      title: '',
      description: '',
      created_at: new Date().toISOString(),
    };
  });
};

interface PlayerData {
  id: string;
  profile_id: string;
  team_id?: string | null;
  position?: string | null;
  jersey_number?: number | null;
  hometown?: string | null;
  height?: string | null;
  grad_year?: number | null;
  profile_picture_url?: string | null;
  dominant_hand?: string | null;
  video_urls?: unknown;
  stats?: unknown;
  skill_levels?: unknown;
  games_played?: number | null;
  join_date?: string | null;
  profile?: unknown;
}

export const transformPlayerData = (playerData: PlayerData): Player => {
  return {
    id: playerData.id,
    profile_id: playerData.profile_id,
    team_id: playerData.team_id,
    position: playerData.position,
    jersey_number: playerData.jersey_number,
    hometown: playerData.hometown,
    height: playerData.height,
    grad_year: playerData.grad_year,
    profile_picture_url: playerData.profile_picture_url,
    dominant_hand: playerData.dominant_hand,
    video_urls: transformVideoUrls(playerData.video_urls),
    stats: typeof playerData.stats === 'object' && playerData.stats !== null 
      ? playerData.stats as { serves: number; spikes: number; blocks: number; digs: number; assists: number; }
      : { serves: 0, spikes: 0, blocks: 0, digs: 0, assists: 0 },
    skill_levels: typeof playerData.skill_levels === 'object' && playerData.skill_levels !== null
      ? playerData.skill_levels as { serving: number; spiking: number; blocking: number; passing: number; setting: number; }
      : { serving: 50, spiking: 50, blocking: 50, passing: 50, setting: 50 },
    games_played: playerData.games_played || 0,
    join_date: playerData.join_date || new Date().toISOString().split('T')[0],
    profile: Array.isArray(playerData.profile) ? playerData.profile[0] : playerData.profile
  };
};
